module.exports = __webpack_public_path__ + "static/basics_of_video_processing_4-1a203f1fb6f4628a982540752ee4e064.png";